import React, { useEffect, useState } from 'react';

import semver from 'semver';

import NewVersionDialog from 'dialogs/NewVersionDialog';
import AppApi from 'api/appApi';

const CURRENT_VERSION = '1.0.3';

const VersionChecker = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const intervalId = setInterval(async () => {
            try {
                const response = await AppApi.getVersion();

                if (semver.lt(CURRENT_VERSION, response.data.version)) {
                    setIsOpen(true);
                }
            } catch (err) {
                console.log('err');
            }
        }, 60000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const handleClose = () => {
        setIsOpen(false);
    };

    return <NewVersionDialog open={isOpen} onClose={handleClose} />;
};

export default VersionChecker;
